import { OrdersModel } from '@app/core/models';
import { Action } from '@ngrx/store';

/**
 * OrdersActionTypes
 */
export const enum OrdersActionTypes {
  LOAD_ORDERS = '[Orders] Load Orders',
  LOAD_ORDERS_SUCCESS = '[Orders] Load Orders Success',
  LOAD_ORDERS_ERROR = '[Orders] Load Orders Fail',
  PATCH_ORDERS = '[Orders] Patch Orders',
  LOAD_ORDERS_OPEN = '[Orders] Load Open Orders',
  LOAD_ORDERS_DELAYED = '[Orders] Load Delayed Orders',
  LOAD_ORDERS_ATTN = '[Orders] Load Needs Attn Orders',
  LOAD_ORDERS_COMPLETED = '[Orders] Load Completed Orders',
}

/**
 * LoadOrders
 */
interface LoadOrders extends Action {
  type: OrdersActionTypes.LOAD_ORDERS;
  payload: any;
}

/**
 * LoadOrdersSuccess
 */
interface LoadOrdersSuccess extends Action {
  type: OrdersActionTypes.LOAD_ORDERS_SUCCESS;
  payload: OrdersModel[];
}

/**
 * LoadOrdersError
 */
interface LoadOrdersError extends Action {
  type: OrdersActionTypes.LOAD_ORDERS_ERROR;
  payload: any;
}

/**
 * LoadOrdersOpen
 */
interface LoadOrdersOpen extends Action {
  type: OrdersActionTypes.LOAD_ORDERS_OPEN;
  payload: any;
}

/**
 * LoadOrdersDelayed
 */
interface LoadOrdersDelayed extends Action {
  type: OrdersActionTypes.LOAD_ORDERS_DELAYED;
  payload: any;
}

/**
 * LoadOrdersAttn
 */
interface LoadOrdersAttn extends Action {
  type: OrdersActionTypes.LOAD_ORDERS_ATTN;
  payload: any;
}

/**
 * LoadOrdersCompleted
 */
interface LoadOrdersCompleted extends Action {
  type: OrdersActionTypes.LOAD_ORDERS_COMPLETED;
  payload: any;
}

/**
 * OrdersActions
 */
export type OrdersActions =
  | LoadOrders
  | LoadOrdersSuccess
  | LoadOrdersError
  | LoadOrdersOpen
  | LoadOrdersDelayed
  | LoadOrdersAttn
  | LoadOrdersCompleted;
